type Props = {
  className?: string;
};

export default function GrowthIcon({ className = '' }: Props) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16 6.5H20.9941L21.0908 6.51074C21.1226 6.51742 21.1536 6.52727 21.1836 6.54004L21.1885 6.54199C21.3104 6.59273 21.4073 6.68959 21.458 6.81152L21.46 6.81641C21.4727 6.8464 21.4826 6.87744 21.4893 6.90918L21.5 7.00586V12C21.5 12.1326 21.4473 12.2598 21.3535 12.3535C21.2598 12.4473 21.1326 12.5 21 12.5C20.8674 12.5 20.7402 12.4473 20.6465 12.3535C20.5527 12.2597 20.5 12.1326 20.5 12V8.20117L19.6465 9.05664L13.3564 15.3564L13.3545 15.3574C13.308 15.4043 13.2533 15.4424 13.1924 15.4678C13.1315 15.4931 13.066 15.5059 13 15.5059C12.934 15.5059 12.8685 15.4931 12.8076 15.4678C12.7467 15.4424 12.691 15.4043 12.6445 15.3574H12.6436L9.35449 12.0566L9 11.7021L8.64648 12.0566L3.35645 17.3564L3.35449 17.3574C3.30801 17.4043 3.25331 17.4424 3.19238 17.4678C3.13148 17.4931 3.06598 17.5059 3 17.5059C2.93404 17.5059 2.86851 17.4931 2.80762 17.4678C2.74669 17.4424 2.69102 17.4043 2.64453 17.3574L2.6416 17.3555L2.5791 17.2793C2.56075 17.252 2.54493 17.2229 2.53223 17.1924C2.50686 17.1315 2.49414 17.066 2.49414 17C2.49414 16.934 2.50686 16.8685 2.53223 16.8076C2.55761 16.7467 2.59474 16.691 2.6416 16.6445L2.64355 16.6436L8.64453 10.6426C8.69101 10.5957 8.74669 10.5576 8.80762 10.5322C8.86851 10.5069 8.93404 10.4941 9 10.4941C9.06598 10.4941 9.13148 10.5069 9.19238 10.5322C9.25331 10.5576 9.30801 10.5957 9.35449 10.6426H9.35547L12.6455 13.9434L12.999 14.2979L19.7969 7.5H16C15.8674 7.5 15.7402 7.44726 15.6465 7.35352C15.5527 7.25975 15.5 7.13261 15.5 7C15.5 6.86739 15.5527 6.74025 15.6465 6.64648C15.7402 6.55274 15.8674 6.5 16 6.5Z"
        fill="#72778A"
        stroke="currentColor"
      />
    </svg>
  );
}
